<template>
    <div :class="`physician-card ${order.OrderId === selectedOrder.OrderId ? 'active' : ''}`">
        <div class="d-flex flex-column flex-grow-1 me-3">
            <template v-if="!showEditPhysician && !isUpdateInProgress">
                <strong class="text-capitalize" v-if="order.PhysicianFirstName || order.PhysicianLastName">
                    <FormatName
                        :first-name="order.PhysicianFirstName"
                        :last-name="order.PhysicianLastName"
                        format="FN LN"
                    >
                    </FormatName>
                </strong>
                <span v-else>
                    Physician Not Added
                    <i
                        class="ms-1 fas fa-exclamation-triangle text-warning"
                        v-tooltip="{ title: 'Order cannot be selected without a physician' }"
                    ></i>
                </span>
            </template>
            <strong class="d-flex text-success align-items-center" v-if="!showEditPhysician && isUpdateInProgress">
                <i class="far fa-save font-size-xl me-1 animated flash infinite slow"></i>Saving Physician...
            </strong>
            <template v-if="showEditPhysician && !isUpdateInProgress">
                <TypeaheadInput
                    :getData="getPhysicianList"
                    :value="selectedPhysician"
                    placeholder="Type to Search Physician..."
                    :character-limit="3"
                    v-on:valueChanged="selectedPhysicianChanged"
                >
                </TypeaheadInput>
            </template>
            <span :class="`${showEditPhysician || isUpdateInProgress ? 'mt-2' : ''}`">
                ordered on <b>{{ formatDate(order.OrderDate) }}</b>
            </span>
            <section class="d-flex mt-1">
                <span :class="`task-status badge badge-pill badge-${taskStatusNameColor(order.OrderStatus)}`">
                    {{ order.OrderStatus }}
                </span>
                <span
                    class="ms-2 task-status badge badge-pill badge-success"
                    v-if="order.OrderId === selectedOrder.OrderId"
                >
                    Selected
                </span>
            </section>
        </div>
        <div class="ms-auto d-flex">
            <template v-if="!showEditPhysician">
                <button type="button" class="btn btn-xs py-0 btn-outline-primary" @click="openOrder(order)">
                    Open Order
                </button>
                <button
                    type="button"
                    class="btn btn-xs py-0 btn-primary ms-1"
                    @click="openAddPhysicianToOrder()"
                    v-if="!order.PhysicianFirstName && !order.PhysicianLastName"
                >
                    Add Physician
                </button>
                <button
                    type="button"
                    class="btn btn-xs py-0 btn-success ms-1"
                    @click="selectOrder(order)"
                    v-if="
                        (order.PhysicianFirstName || order.PhysicianLastName) && order.OrderId !== selectedOrder.OrderId
                    "
                >
                    Select Order
                </button>
            </template>
            <template v-if="!isUpdateInProgress && showEditPhysician">
                <button type="button" class="btn btn-xs py-0 btn-success" @click="addPhysicianToOrder()">Save</button>
                <button
                    type="button"
                    class="btn btn-xs py-0 btn-outline-secondary ms-1"
                    @click="closeAddPhysicianToOrder()"
                >
                    Cancel
                </button>
            </template>
        </div>
    </div>
</template>

<script lang="ts" src="./PhysicianOrderCard.ts"></script>
